import React from 'react';
import { Loader } from 'cdk-radial';
import Page from '../page/index';
import './loading.scss';

const COLOR_STROKE = '#006CFA';

function Loading(props) {
  return (
    <div className="loading-container">
      <Loader
        spinnerClassName="loading"
        style={{ stroke: COLOR_STROKE }}
        label={props.label}
      />
    </div>
  );
}

function LoadingWithPageHeader() {
  return (
    <Page email={''} dealershipName={''}>
      <div className="loading-container">
        <Loader spinnerClassName="loading" style={{ stroke: COLOR_STROKE }} />
      </div>
    </Page>
  );
}

export { Loading, LoadingWithPageHeader };